(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    // ── Scroll reveal ──────────────────────────────────────────
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } });
        }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('pv-in');
    });

    // ── Clone the top trust-pill row into the footer slot ──────
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();

    // ── Benefit cards → detail popup (how each benefit is driven by the B complex) ──
    (function () {
      var modal = document.getElementById('pv-benefit-modal');
      if (!modal) return;
      var icon  = modal.querySelector('#pv-benefit-modal-icon');
      var title = modal.querySelector('#pv-benefit-modal-title');
      var claim = modal.querySelector('#pv-benefit-modal-claim');
      var body  = modal.querySelector('#pv-benefit-modal-body');
      function openModal(card) {
        var ic = card.querySelector('.pv-benefit-ic');
        icon.innerHTML  = ic ? ic.innerHTML : '';
        title.textContent = card.getAttribute('data-title')  || '';
        claim.textContent = card.getAttribute('data-claim')  || '';
        body.textContent  = card.getAttribute('data-detail') || '';
        modal.classList.add('pv-open');
        document.body.style.overflow = 'hidden';
      }
      function closeModal() { modal.classList.remove('pv-open'); document.body.style.overflow = ''; }
      document.querySelectorAll('[data-pv-benefit]').forEach(function (c) {
        c.addEventListener('click', function () { openModal(c); });
      });
      modal.querySelectorAll('[data-pv-bmodal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    })();
  });
})();

/* Gold title shine: full-width hero H1 ~1s after load; section titles sweep on scroll-in */
;(function(){
  function shine(el, slow){ if(!el||el.dataset.pvShone) return; el.dataset.pvShone='1'; el.classList.add('pv-shine-go'); if(slow) el.classList.add('pv-shine-slow'); el.addEventListener('animationend', function(){ el.classList.remove('pv-shine-go'); el.classList.remove('pv-shine-slow'); }, {once:true}); }
  var h1=document.querySelector('.pv-fhero-h1');
  window.addEventListener('load', function(){ setTimeout(function(){ shine(h1, true); }, 3000); });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ shine(e.target); io.unobserve(e.target); } }); }, { threshold:0.6 });
    document.querySelectorAll('.pv-section-h.pv-shine-on').forEach(function(h){ io.observe(h); });
  }
})();

/* Hero video fade-in (DESKTOP ONLY, >=900px). The poster IMG behind it is always visible, so
   Safari/iOS never shows a grey video box. As soon as the video has a real frame (readyState >= 2)
   it fades in over the identical poster. If autoplay is ever blocked, the poster simply remains. */
;(function(){
  var v = document.querySelector('.pv-fhero-video');
  if(!v || v.tagName !== 'VIDEO') return;
  var poster = document.querySelector('.pv-fhero-poster');
  // Only fade the video in when it is ACTUALLY playing. If autoplay is blocked
  // (e.g. iOS Low Power Mode) it stays hidden and the <img> poster shows instead,
  // so a paused video never sits there with iOS's native play-button overlay.
  // Once the video is playing we fade the poster out, so the poster image never
  // ghosts through where the video masks/fades into the green at the bottom.
  function show(){ if (!v.paused) { v.classList.add('pv-playing'); if (poster) poster.style.opacity = '0'; } }
  function hide(){ v.classList.remove('pv-playing'); if (poster) poster.style.opacity = ''; }
  v.addEventListener('playing', show);
  v.addEventListener('timeupdate', show);
  ['pause','stalled','error','suspend','emptied'].forEach(function(ev){ v.addEventListener(ev, hide); });
  function tryPlay(){ try { var p = v.play(); if (p && p.then) { p.then(show).catch(function(){ hide(); }); } else if (!v.paused) { show(); } } catch(e) { hide(); } }

  // ── Deferred load (page-speed) ──────────────────────────────
  // The <video> ships with NO downloadable source (held in data-src) and no
  // autoplay/preload, so it costs ZERO bytes during initial load — the poster
  // <img> is the LCP and paints instantly. We attach the real source and start
  // playback only AFTER the page has fully loaded and gone idle, so the heavy
  // video never competes with first paint. It then fades in over the poster.
  var started = false;
  function loadVideo(){
    if (started) return; started = true;
    var srcs = v.querySelectorAll('source[data-src]');
    if (!srcs.length) { tryPlay(); return; }
    for (var i = 0; i < srcs.length; i++){ srcs[i].setAttribute('src', srcs[i].getAttribute('data-src')); }
    v.setAttribute('preload', 'auto');
    try { v.load(); } catch(e) {}
    if (v.readyState >= 2) tryPlay(); else v.addEventListener('canplay', tryPlay, { once:true });
    document.addEventListener('touchstart', tryPlay, { once:true, passive:true });
  }
  // The compressed ~2.4MB loop plays on DESKTOP ONLY (>=900px), and only AFTER
  // load + idle so it never competes with first paint. On phones and tablets the
  // still poster image is the hero (owner directive 2026-07-06: keep mobile light
  // and fast). We also skip it on data-saver or genuinely slow links.
  function eligible(){
    var desktop = window.matchMedia ? window.matchMedia('(min-width: 900px)').matches : (window.innerWidth >= 900);
    if (!desktop) return false;
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c){ if (c.saveData) return false; if (['slow-2g','2g','3g'].indexOf(c.effectiveType) !== -1) return false; }
    return true;
  }
  function schedule(){
    if (!eligible()) return; // poster stays, no video download
    var idle = window.requestIdleCallback || function(fn){ return setTimeout(fn, 1200); };
    idle(loadVideo, { timeout: 3000 });
  }
  if (document.readyState === 'complete') setTimeout(schedule, 400);
  else window.addEventListener('load', function(){ setTimeout(schedule, 600); });
})();

/* Stat count-up: number animates 0 -> target when scrolled into view */
;(function(){
  var els = document.querySelectorAll('[data-pv-countup]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return; io.unobserve(e.target);
      var n = e.target.querySelector('.pv-sci-stat-num'); if (!n) return;
      var to = parseInt(n.getAttribute('data-count-to'), 10) || 0;
      if (reduce) { n.textContent = to; return; }
      var t0 = null;
      requestAnimationFrame(function step(ts){
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / 1300, 1);
        n.textContent = Math.round((1 - Math.pow(1 - p, 3)) * to);
        if (p < 1) requestAnimationFrame(step);
      });
    });
  }, { threshold: 0.5 });
  els.forEach(function(el){ io.observe(el); });
})();
